import React, { useEffect, useState } from "react";
import MainCard from "../../components/Maincard";
import {
  Box,
  Button,
  FormControl,
  Select,
  Checkbox,
  ListItemText,
  Chip,
  CircularProgress,
  Grid,
  Menu,
  MenuItem,
  Stack,
  styled,
  TextField,
  Typography,
  Paper,
  TableHead,
  TableRow,
  TableCell,
  Table,
  TableBody,
  TablePagination,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { useGetTokenOrLogout } from "../../utils/token";
import HeadingCard from "../../newTestPrep/newComponent/NewCardsComp/HeadingCard";
import SearchButton from "../../newTestPrep/newComponent/NewButtonComp/SearchButton";
import ClearButtonComp from "../../newTestPrep/newComponent/NewButtonComp/ResetButtonComp";
import CustomNoRowsOverlay from "../../newTestPrep/newComponent/TableCustomeComp/CustomNoRowsOverlay";
import CustomAutocompleteComp from "../../newTestPrep/newComponent/AutocompleteComp";
import StyledTableContainer from "../../newTestPrep/newComponent/TableContainer";
import CustomTextFieldComp from "../../newTestPrep/newComponent/customTextFieldComp";

export default function AdvisorReport() {
  const navigate = useNavigate();

  const getTokenOrLogout = useGetTokenOrLogout();
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
  const userId=localStorage.getItem('userId')
  const [branchlist, setBranchlist] = useState([]);
  const [branch, setBranch] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
    const [countryList, setCountryList] = useState([]);
    const [countryName, setCountryName] = useState(101);

  // Pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

   useEffect(() => {
      fetch(`${API_ENDPOINT}country`)
        .then((response) => response.json())
        .then((data) => {
          const filteredCountry = data.filter(
            (i) => i.country_name === "India" || i.country_name === "Nepal"
          );
          setCountryList(filteredCountry);
        })
        .catch((error) => {
          console.error("Error fetching state:", error);
        });
    }, []);
  
    const handleChangeCountry = (e) => {
      setBranch([])
      setCountryName(e.target.value);
    };
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}branch/bycountry/${countryName}`);
        if (response.ok) {
          const data = await response.json();

          setBranchlist(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [countryName]);

  const allbranchList = [{ branch_name: "Select All" }, ...branchlist];
  const handelbranchchange = (event, value) => {
    if (value.some((option) => option.branch_name === "Select All")) {
      setBranch(branchlist);
    } else {
      setBranch(value);
    }
  };

  const handleSearch = async () => {
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };

    try {
      setLoading(true);
      const response = await fetch(`${API_ENDPOINT}route2.0/advisorbybranch`, {
        method: "POST",
        headers,
        body: JSON.stringify({ branch_id: branch.map((i) => i.id) , country_id:countryName , user_id:parseInt(userId) }),
      });

      if (response.status === 200) {
        const data = await response.json();
        // Handle successful response
        setData(data);
        setLoading(false);
      } else if (response.status === 404) {
        navigate("/page404");
      } else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        navigate("/page403");
      } else if (response.status === 440) {
        navigate("/page440");
      } else {
        navigate("/page500");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      navigate("/page500");
    }
  };

// const handleclick = (row) => {
//   navigate(`/advisorrevenue/${row.user_id}`, {
//     state: { country_id: countryName },
//   });
// };

const handleclick = (row) => {
  localStorage.setItem("countryid", JSON.stringify({
  
   countryName
  }));
  const newTab = window.open(`/advisorrevenue/${row.user_id}`, "_blank");
  if (newTab) {
    newTab.focus();
  }
};



  // const handleclick = (row) => {
  //   // Handle the "View More" action here

  //   const url = `/advisorrevenue/${row.user_id}`;
  //   const newState = { country_id :countryName};

  //   // Open link in new tab
  //   const newTab = window.open(url, "_blank");

  //   // If new tab opened successfully, navigate with state data
  //   if (newTab) {
  //     newTab.onload = () => {
  //       newTab.history.replaceState(newState, "", url);
  //     };
  //   } else {
  //     // If new tab was blocked by browser, navigate with state data in current tab
  //     navigate(url, { state: newState });
  //   }
  // };

  const handleReset = () => {
    setData([]);
    setBranch([]);
  };
  const columns = [
    {
      field: "name",
      headerName: "Name of Advisor",
      flex: 2,
      headerAlign: "center",
      headerClassName: "super-app-theme--header",
      align: "center",
      renderCell: (params) => (
        <>
          <Typography
            color="primary"
            sx={{ cursor: "pointer" }}
            onClick={() => handleclick(params.row)}
          >
            {params.row?.name}
          </Typography>
        </>
      ),
    },

    {
      field: "branch",
      headerName: " Branch",
      flex: 1,
      headerAlign: "center",
      headerClassName: "super-app-theme--header",
      align: "center",
      renderCell: (params) => (
        <>
          <Typography>{params.row?.branch}</Typography>
        </>
      ),
    },
  ];

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3} md={2.5} lg={2}>
          <HeadingCard label="Advisor Report" />
        </Grid>
        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={3}>
   <Grid item xs={12} sm={4} md={3}>
                    <Typography variant="h6">Select Country</Typography>
                    <CustomTextFieldComp
                      size="normal"
                      select
                      value={countryName}
                      onChange={handleChangeCountry}
                      fullWidth
                      InputProps={{ style: { borderRadius: "10px" } }}
                    >
                      {countryList?.map((country) => (
                        <MenuItem key={country.id} value={country.id}>
                          {country.country_name}
                        </MenuItem>
                      ))}
                    </CustomTextFieldComp>
                  </Grid>

              <Grid item xs={12} md={3}>
                <FormControl sx={{ mb: 1, width: "100%" }}>
                  <Typography variant="h6"> Center / Branch</Typography>

                  <CustomAutocompleteComp
                    size="small"
                    value={branch}
                    multiple
                    onChange={handelbranchchange}
                    options={allbranchList}
                    getOptionLabel={(option) => option.branch_name}
                    tooltipContent={(option) => option.branch_name}
                    placeholder="Please Select Branches"
                  />
                </FormControl>
              </Grid>

              <Grid item xs={4} lg={6} mt={2} container gap={1}>
                <SearchButton
                  size="small"
                  showIcon={true}
                  onClick={handleSearch}
                />

                <ClearButtonComp size="small" onClick={handleReset} />
              </Grid>
            </Grid>
          </MainCard>
        </Grid>

        <Grid item xs={12}>
          <MainCard>
            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CircularProgress />
              </Box>
            ) : data?.length === 0 ? (
              <Grid
                item
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <Typography variant="h5">No data available</Typography>
              </Grid>
            ) : (
              <StyledTableContainer component={Paper} borderLeft={true}>
                <Table
                  sx={{ minWidth: 650, tableLayout: "fixed" }}
                  aria-label="simple table"
                  stickyHeader
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Name Of Advisor</TableCell>
                      <TableCell>Branch</TableCell>
                    </TableRow>
                  </TableHead>

                  {data
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableBody>
                        <TableRow
                          key={row.name}
                          style={{
                            backgroundColor:
                              index % 2 === 0 ? "#f0f0f0" : "inherit",
                          }}
                        >
                          <TableCell sx={{ borderLeft: "0.1px solid #C3C3C3" }}>
                            <Box
                              color="#2f96f5"
                              sx={{ cursor: "pointer" }}
                              onClick={() => handleclick(row)}
                            >
                              {" "}
                              {row?.name}
                            </Box>
                          </TableCell>
                          <TableCell>{row?.branch}</TableCell>
                        </TableRow>
                      </TableBody>
                    ))}
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={data.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </StyledTableContainer>
            )}
          </MainCard>
        </Grid>
      </Grid>
    </>
  );
}
